import apiClient from "@/services/api/apiClientStudent";
import { BASE_URL } from "@utils/constants";

export const getLots = (subTab) => async (dispatch, getState) => {
  const state = getState();
  const { userId, token, role } = state.studentAuth;

  const requestOptions = {
    method: "GET",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    },
  };

  const url = role === 'REVIEWER' ? subTab === 'assigned' ? `api/reviewer/tt/assigned-lots?reviewerId=${userId}` : `api/reviewer/tt/completed-lots?reviewerId=${userId}`
    : subTab === 'assigned' ? `api/student/tt/assigned-lots?studentId=${userId}` : `api/student/tt/completed-lots?studentId=${userId}`

  try {
    const response = await apiClient(
      BASE_URL + url,
      requestOptions
    );
    return response;
  } catch (error) {
    console.log(error);
    return error;
  }
};


export const getLotsForTTS = (subTab) => async (dispatch, getState) => {
  const state = getState();
  const { userId, token, role } = state.studentAuth;

  const requestOptions = {
    method: "GET",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    },
  };

  const url = role === 'REVIEWER' ? subTab === 'assigned' ? `api/reviewer/ts/assigned-lots?reviewerId=${userId}` : `api/reviewer/ts/completed-lots?reviewerId=${userId}`
    : subTab !== 'assigned' ? `api/student/ts/completed-lots?studentId=${userId}` : `api/student/ts/assigned-lots?studentId=${userId}`

  try {
    const response = await apiClient(
      BASE_URL + url,
      requestOptions
    );
    return response;
  } catch (error) {
    console.log(error);
    return error;
  }
};



export const pullMoreLots = (selectedLanguage) => async (dispatch, getState) => {
  const state = getState();
  const { userId, token } = state.studentAuth;

  const requestOptions = {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    },
  };

  try {
    const response = await apiClient(
      BASE_URL + `api/student/tt/pull-sentencelot?studentId=${userId}&targetId=${selectedLanguage}`,
      requestOptions
    );
    return response;
  } catch (error) {
    console.log(error);
    return error;
  }
};


export const pullMoreLotsForTTS = (selectedLanguage) => async (dispatch, getState) => {
  const state = getState();
  const { userId, token } = state.studentAuth;

  const requestOptions = {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    },
  };

  try {
    const response = await apiClient(
      BASE_URL + `api/student/ts/pull-sentencelot?studentId=${userId}&sourceId=${selectedLanguage}`,
      requestOptions
    );
    return response;
  } catch (error) {
    console.log(error);
    return error;
  }
};



export const pullMoreLotsForDict = (selectedDomain, selectedLanguage) => async (dispatch, getState) => {
  const state = getState();
  const { userId, token } = state.studentAuth;

  const requestOptions = {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    },
  };

  try {
    const response = await apiClient(
      BASE_URL + `api/student/dt/pull-words?studentId=${userId}&domainId=${selectedDomain}&targetId=${selectedLanguage}`,
      requestOptions
    );
    return response;
  } catch (error) {
    console.log(error);
    return error;
  }
};


export const releaseLotForUser = (lotId, selectedLanguageId) => async (dispatch, getState) => {
  const state = getState();
  const { userId, token } = state.studentAuth;

  const requestOptions = {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    },
  };

  try {
    const response = await apiClient(
      BASE_URL + `api/student/tt/release-sentencelot?studentId=${userId}&lotId=${lotId}&targetId=${selectedLanguageId}`,
      requestOptions
    );
    return response;
  } catch (error) {
    console.log(error);
    return error;
  }
};

export const releaseLotForUserTTS = (lotId, selectedLanguageId) => async (dispatch, getState) => {
  const state = getState();
  const { userId, token } = state.studentAuth;

  const requestOptions = {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    },
  };

  try {
    const response = await apiClient(
      BASE_URL + `api/student/ts/release-sentencelot?studentId=${userId}&lotId=${lotId}&sourceId=${selectedLanguageId}`,
      requestOptions
    );
    return response;
  } catch (error) {
    console.log(error);
    return error;
  }
};

export const releaseLotForUserDict = (lotId, selectedLanguageId) => async (dispatch, getState) => {
  const state = getState();
  const { userId, token } = state.studentAuth;

  const requestOptions = {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    },
  };

  try {
    const response = await apiClient(
      BASE_URL + `api/student/dt/release-words?studentId=${userId}&lotId=${lotId}&targetId=${selectedLanguageId}`,
      requestOptions
    );
    return response;
  } catch (error) {
    console.log(error);
    return error;
  }
};



export const getKnownLangaugesForStudent = (payload) => async (dispatch, getState) => {
  const state = getState();
  const { userId, token } = state.studentAuth;

  const requestOptions = {
    method: "GET",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  };

  try {
    const response = await apiClient(
      BASE_URL + `api/student/ts/languages?studentId=${userId}`,
      requestOptions
    );
    return response;
  } catch (error) {
    console.log(error);
    return error;
  }
};

export const getKnownLangaugesForStudentDict = (payload) => async (dispatch, getState) => {
  const state = getState();
  const { userId, token } = state.studentAuth;

  const requestOptions = {
    method: "GET",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  };

  try {
    const response = await apiClient(
      BASE_URL + `api/student/dt/languages?studentId=${userId}`,
      requestOptions
    );
    return response;
  } catch (error) {
    console.log(error);
    return error;
  }
};


export const getKnownDomainsForStudentDict = (payload) => async (dispatch, getState) => {
  const state = getState();
  const { userId, token } = state.studentAuth;

  const requestOptions = {
    method: "GET",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  };

  try {
    const response = await apiClient(
      BASE_URL + `api/student/dt/domains?studentId=${userId}`,
      requestOptions
    );
    return response;
  } catch (error) {
    console.log(error);
    return error;
  }
};



export const getSentencesInALot = (lotId, targetId) => async (dispatch, getState) => {
  const state = getState();
  const { userId, token, role } = state.studentAuth;

  const requestOptions = {
    method: "GET",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    },
  };

  const url = role === 'REVIEWER' ? `api/reviewer/tt/sentences?reviewerId=${userId}&lotId=${lotId}&targetId=${targetId}` : `api/student/tt/sentences?studentId=${userId}&lotId=${lotId}&targetId=${targetId}`;

  try {
    const response = await apiClient(
      BASE_URL + url,
      requestOptions
    );
    return response;
  } catch (error) {
    console.log(error);
    return error;
  }
};


export const getSentencesInALotTTS = (lotId, targetId, studentId) => async (dispatch, getState) => {
  const state = getState();
  const { userId, token, role } = state.studentAuth;

  const requestOptions = {
    method: "GET",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    },
  };

  const url = role === 'REVIEWER' ? `api/reviewer/ts/sentences?reviewerId=${userId}&lotId=${lotId}&sourceId=${targetId}&studentId=${studentId}` : `api/student/ts/sentences?studentId=${userId}&lotId=${lotId}&sourceId=${targetId}`;

  try {
    const response = await apiClient(
      BASE_URL + url,
      requestOptions
    );
    return response;
  } catch (error) {
    console.log(error);
    return error;
  }
};


export const getSentencesInALotDict = (lotId, targetId, studentId) => async (dispatch, getState) => {
  const state = getState();
  const { userId, token, role } = state.studentAuth;

  const requestOptions = {
    method: "GET",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    },
  };

  const url = role === 'REVIEWER' ? `api/reviewer/dt/words?reviewerId=${userId}&lotId=${lotId}&targetId=${targetId}` : `api/student/dt/words?studentId=${userId}&lotId=${lotId}&targetId=${targetId}`;

  try {
    const response = await apiClient(
      BASE_URL + url,
      requestOptions
    );
    return response;
  } catch (error) {
    console.log(error);
    return error;
  }
};

export const getRejectedSentencesForReviewer = (tab) => async (dispatch, getState) => {
  const state = getState();
  const { userId, token, role } = state.studentAuth;

  const requestOptions = {
    method: "GET",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    },
  };

  const url = tab === 'ttt' ? `api/reviewer/tt/assigned-sentences?reviewerId=${userId}` : tab === 'tts' ? `api/reviewer/ts/assigned-sentences?reviewerId=${userId}` : tab === 'dict' ? `api/reviewer/dt/assigned-sentences?reviewerId=${userId}` : `api/reviewer/tt/assigned-sentences?reviewerId=${userId}`;

  try {
    const response = await apiClient(
      BASE_URL + url,
      requestOptions
    );
    return response;
  } catch (error) {
    console.log(error);
    return error;
  }
};


export const getRejectedSentencesInALot = (lotId, targetId, studentId=null) => async (dispatch, getState) => {
  const state = getState();
  const { userId, token, role } = state.studentAuth;

  const requestOptions = {
    method: "GET",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    },
  };

  const url = role === 'REVIEWER' ? `api/reviewer/ts/flagged-sentences?reviewerId=${userId}&lotId=${lotId}&sourceId=${targetId}&studentId=${studentId}` : `api/student/ts/flagged-sentences?studentId=${userId}&lotId=${lotId}&sourceId=${targetId}`;

  try {
    const response = await apiClient(
      BASE_URL + url,
      requestOptions
    );
    return response;
  } catch (error) {
    console.log(error);
    return error;
  }
};

export const getRejectedSentencesInALotTTT = (lotId, targetId) => async (dispatch, getState) => {
  const state = getState();
  const { userId, token, role } = state.studentAuth;

  const requestOptions = {
    method: "GET",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    },
  };

  const url = role === 'REVIEWER' ? `api/reviewer/tt/flagged-sentences?reviewerId=${userId}&lotId=${lotId}&targetId=${targetId}` : `api/student/tt/flagged-sentences?studentId=${userId}&lotId=${lotId}&targetId=${targetId}`;

  try {
    const response = await apiClient(
      BASE_URL + url,
      requestOptions
    );
    return response;
  } catch (error) {
    console.log(error);
    return error;
  }
};



export const getRejectedSentencesInALotDict = (lotId, targetId) => async (dispatch, getState) => {
  const state = getState();
  const { userId, token, role } = state.studentAuth;

  const requestOptions = {
    method: "GET",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    },
  };

  const url = role === 'REVIEWER' ? `api/reviewer/dt/flagged-words?studentId=${userId}&lotId=${lotId}&targetId=${targetId}` : `api/student/dt/flagged-words?studentId=${userId}&lotId=${lotId}&targetId=${targetId}`;

  try {
    const response = await apiClient(
      BASE_URL + url,
      requestOptions
    );
    return response;
  } catch (error) {
    console.log(error);
    return error;
  }
};


export const validateSentenceForStudent = (payload) => async (dispatch, getState) => {
  const state = getState();
  const { token, role, userId } = state.studentAuth;

  const requestOptions = {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    },
    body: JSON.stringify(payload)
  };

  const url = role === 'REVIEWER' ? `api/reviewer/tt/validate-sentence?reviewerId=${userId}` : `api/student/tt/validate-sentence?studentId=${userId}`;

  try {
    const response = await apiClient(
      BASE_URL + url,
      requestOptions
    );
    return response;
  } catch (error) {
    console.log(error);
    return error;
  }
};


export const reviewSentenceForStudent = (payload) => async (dispatch, getState) => {
  const state = getState();
  const { token, userId } = state.studentAuth;

  const requestOptions = {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    },
    body: JSON.stringify(payload)
  };

  try {
    const response = await apiClient(
      BASE_URL + `api/student/tt/review-sentence?studentId=${userId}`,
      requestOptions
    );
    return response;
  } catch (error) {
    console.log(error);
    return error;
  }
};


export const reviewSentenceForStudentTTS = (payload) => async (dispatch, getState) => {
  const state = getState();
  const { token, userId } = state.studentAuth;

  const requestOptions = {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    },
    body: JSON.stringify(payload)
  };

  try {
    const response = await apiClient(
      BASE_URL + `api/student/ts/review-sentence?studentId=${userId}`,
      requestOptions
    );
    return response;
  } catch (error) {
    console.log(error);
    return error;
  }
};


export const reviewSentenceForStudentDict = (payload) => async (dispatch, getState) => {
  const state = getState();
  const { token, userId } = state.studentAuth;

  const requestOptions = {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    },
    body: JSON.stringify(payload)
  };

  try {
    const response = await apiClient(
      BASE_URL + `api/student/dt/review-word?studentId=${userId}`,
      requestOptions
    );
    return response;
  } catch (error) {
    console.log(error);
    return error;
  }
};



export const discardSentenceForUser = (sentenceId, targetId = '') => async (dispatch, getState) => {
  const state = getState();
  const { token, userId } = state.studentAuth;

  const requestOptions = {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    },
  };

  try {
    const response = await apiClient(
      BASE_URL + `api/reviewer/tt/discard-sentence?reviewerId=${userId}&sentenceId=${sentenceId}&targetId=${targetId}`,
      requestOptions
    );
    return response;
  } catch (error) {
    console.log(error);
    return error;
  }
};


export const discardSentenceForUserDict = (mappingId, targetId) => async (dispatch, getState) => {
  const state = getState();
  const { token, userId } = state.studentAuth;

  const requestOptions = {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    },
  };

  try {
    const response = await apiClient(
      BASE_URL + `api/reviewer/dt/discard-word?reviewerId=${userId}&mappingId=${mappingId}&targetId=${targetId}`,
      requestOptions
    );
    return response;
  } catch (error) {
    console.log(error);
    return error;
  }
};


export const resolveSentenceForUser = (payload) => async (dispatch, getState) => {
  const state = getState();
  const { token, userId } = state.studentAuth;

  const requestOptions = {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    },
    body: JSON.stringify(payload)
  };

  try {
    const response = await apiClient(
      BASE_URL + `api/reviewer/tt/resolve-sentence?reviewerId=${userId}`,
      requestOptions
    );
    return response;
  } catch (error) {
    console.log(error);
    return error;
  }
};


export const resolveSentenceForUserDict = (payload) => async (dispatch, getState) => {
  const state = getState();
  const { token, userId } = state.studentAuth;

  const requestOptions = {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    },
    body: JSON.stringify(payload)
  };

  try {
    const response = await apiClient(
      BASE_URL + `api/reviewer/dt/resolve-word?reviewerId=${userId}`,
      requestOptions
    );
    return response;
  } catch (error) {
    console.log(error);
    return error;
  }
};


export const resolveSentenceForUserTTS = (studentId, payload) => async (dispatch, getState) => {
  const state = getState();
  const { token, userId } = state.studentAuth;

  const requestOptions = {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    },
    body: JSON.stringify(payload)
  };

  try {
    const response = await apiClient(
      BASE_URL + `api/reviewer/ts/resolve-sentence?reviewerId=${userId}&studentId=${studentId}`,
      requestOptions
    );
    return response;
  } catch (error) {
    console.log(error);
    return error;
  }
};


export const discardSentenceForUserTTS = (sentenceId, sourceId, studentId) => async (dispatch, getState) => {
  const state = getState();
  const { token, userId } = state.studentAuth;

  const requestOptions = {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    },
  };

  try {
    const response = await apiClient(
      BASE_URL + `api/reviewer/ts/discard-sentence?reviewerId=${userId}&sentenceId=${sentenceId}&sourceId=${sourceId}&studentId=${studentId}`,
      requestOptions
    );
    return response;
  } catch (error) {
    console.log(error);
    return error;
  }
};


export const discardSentenceForReviewer = (sentenceId) => async (dispatch, getState) => {
  const state = getState();
  const { token, userId } = state.studentAuth;

  const requestOptions = {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    },
  };

  try {
    const response = await apiClient(
      BASE_URL + `api/reviewer/tt/discard-assigned-sentence?reviewerId=${userId}&sentenceId=${sentenceId}`,
      requestOptions
    );
    return response;
  } catch (error) {
    console.log(error);
    return error;
  }
};


export const resolveSentenceForReviwer = (payload) => async (dispatch, getState) => {
  const state = getState();
  const { token, userId } = state.studentAuth;

  const requestOptions = {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    },
    body: JSON.stringify(payload)
  };

  try {
    const response = await apiClient(
      BASE_URL + `api/reviewer/tt/resolve-assigned-sentence?reviewerId=${userId}`,
      requestOptions
    );
    return response;
  } catch (error) {
    console.log(error);
    return error;
  }
};



export const rejectSentenceForUser = (sentenceId, targetId, lotId) => async (dispatch, getState) => {
  const state = getState();
  const { token, userId } = state.studentAuth;

  const requestOptions = {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    },
  };

  try {
    const response = await apiClient(
      BASE_URL + `api/reviewer/tt/reject-sentence?reviewerId=${userId}&sentenceId=${sentenceId}&targetId=${targetId}&lotId=${lotId}`,
      requestOptions
    );
    return response;
  } catch (error) {
    console.log(error);
    return error;
  }
};

export const validateSentenceForReviewerTTS = (sentenceId, sourceId, studentId) => async (dispatch, getState) => {
  const state = getState();
  const { token, userId } = state.studentAuth;

  const requestOptions = {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    },
  };

  try {
    const response = await apiClient(
      BASE_URL + `api/reviewer/ts/validate-sentence?reviewerId=${userId}&sentenceId=${sentenceId}&sourceId=${sourceId}&studentId=${studentId}`,
      requestOptions
    );
    return response;
  } catch (error) {
    console.log(error);
    return error;
  }
};



export const validateSentenceDict = (payload) => async (dispatch, getState) => {
  const state = getState();
  const { token, userId, role } = state.studentAuth;

  const requestOptions = {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    },
    body: JSON.stringify(payload)
  };

  try {
    const url = role === 'REVIEWER' ? `api/reviewer/dt/validate-word?reviewerId=${userId}` : `api/student/dt/validate-word?studentId=${userId}`
    const response = await apiClient(
      BASE_URL + url,
      requestOptions
    );
    return response;
  } catch (error) {
    console.log(error);
    return error;
  }
};



export const rejectSentenceForUserTTS = (sentenceId, sourceId, studentId) => async (dispatch, getState) => {
  const state = getState();
  const { token, userId } = state.studentAuth;

  const requestOptions = {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    },
  };

  try {
    const response = await apiClient(
      BASE_URL + `api/reviewer/ts/reject-sentence?reviewerId=${userId}&sentenceId=${sentenceId}&sourceId=${sourceId}&studentId=${studentId}`,
      requestOptions
    );
    return response;
  } catch (error) {
    console.log(error);
    return error;
  }
};


export const rejectSentenceForUserDict = (mappingId, targetId) => async (dispatch, getState) => {
  const state = getState();
  const { token, userId } = state.studentAuth;

  const requestOptions = {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    },
  };

  try {
    const response = await apiClient(
      BASE_URL + `api/reviewer/dt/reject-word?reviewerId=${userId}&mappingId=${mappingId}&targetId=${targetId}`,
      requestOptions
    );
    return response;
  } catch (error) {
    console.log(error);
    return error;
  }
};



export const submitLotForUser = (lotId, targetId) => async (dispatch, getState) => {
  const state = getState();
  const { token, userId, role } = state.studentAuth;

  const requestOptions = {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    },
  };

  const url = role === 'REVIEWER' ? `api/reviewer/tt/mark-lot-completed?reviewerId=${userId}&lotId=${lotId}&targetId=${targetId}` : `api/student/tt/submit-lot?studentId=${userId}&lotId=${lotId}&targetId=${targetId}`;

  try {
    const response = await apiClient(
      BASE_URL + url,
      requestOptions
    );
    return response;
  } catch (error) {
    console.log(error);
    return error;
  }
};

export const submitLotForUserTTS = (lotId, sourceId,studentId=null) => async (dispatch, getState) => {
  const state = getState();
  const { token, userId, role } = state.studentAuth;

  const requestOptions = {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    },
  };

  const url = role === 'REVIEWER' ? `api/reviewer/ts/mark-lot-completed?reviewerId=${userId}&lotId=${lotId}&sourceId=${sourceId}&studentId=${studentId}` : `api/student/ts/submit-lot?studentId=${userId}&lotId=${lotId}&sourceId=${sourceId}`;

  try {
    const response = await apiClient(
      BASE_URL + url,
      requestOptions
    );
    return response;
  } catch (error) {
    console.log(error);
    return error;
  }
};

export const submitLotForUserDict = (lotId, targetId, studentId) => async (dispatch, getState) => {
  const state = getState();
  const { token, userId, role } = state.studentAuth;

  const requestOptions = {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    },
  };

  const url = role === 'REVIEWER' ? `api/reviewer/dt/mark-lot-completed?reviewerId=${userId}&lotId=${lotId}&targetId=${targetId}&studentId=${studentId}` : `api/student/dt/submit-lot?studentId=${userId}&lotId=${lotId}&targetId=${targetId}`;

  try {
    const response = await apiClient(
      BASE_URL + url,
      requestOptions
    );
    return response;
  } catch (error) {
    console.log(error);
    return error;
  }
};


export const fetchWordDetails = (mappingId, targetId) => async (dispatch, getState) => {
  const state = getState();
  const { token, userId, role } = state.studentAuth;

  const requestOptions = {
    method: "GET",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    },
  };

  const url = role === 'REVIEWER' ? `api/reviewer/dt/word-details?mappingId=${mappingId}&reviewerId=${userId}&targetId=${targetId}` : `api/student/dt/word-details?mappingId=${mappingId}&studentId=${userId}&targetId=${targetId}`;

  try {
    const response = await apiClient(
      BASE_URL + url,
      requestOptions
    );
    return response;
  } catch (error) {
    console.log(error);
    return error;
  }
};


export const fetchPartsOfSpeech = () => async (dispatch, getState) => {
  const state = getState();
  const { token, userId, role } = state.studentAuth;

  const requestOptions = {
    method: "GET",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    },
  };

  const url = role === 'REVIEWER' ? `api/reviewer/dt/pos?reviewerId=${userId}` : `api/student/dt/pos?studentId=${userId}`;

  try {
    const response = await apiClient(
      BASE_URL + url,
      requestOptions
    );
    return response;
  } catch (error) {
    console.log(error);
    return error;
  }
};


export const revertLotForUser = (lotId, targetId) => async (dispatch, getState) => {
  const state = getState();
  const { token, userId } = state.studentAuth;

  const requestOptions = {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    },
  };

  try {
    const response = await apiClient(
      BASE_URL + `api/reviewer/tt/revert-lot?reviewerId=${userId}&lotId=${lotId}&targetId=${targetId}`,
      requestOptions
    );
    return response;
  } catch (error) {
    console.log(error);
    return error;
  }
};

export const revertLotForUserTTS = (lotId, sourceId, studentId) => async (dispatch, getState) => {
  const state = getState();
  const { token, userId } = state.studentAuth;

  const requestOptions = {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    },
  };

  try {
    const response = await apiClient(
      BASE_URL + `api/reviewer/ts/revert-lot?reviewerId=${userId}&lotId=${lotId}&sourceId=${sourceId}&studentId=${studentId}`,
      requestOptions
    );
    return response;
  } catch (error) {
    console.log(error);
    return error;
  }
};

export const revertLotForUserDict = (lotId, targetId, studentId) => async (dispatch, getState) => {
  const state = getState();
  const { token, userId } = state.studentAuth;

  const requestOptions = {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    },
  };

  try {
    const response = await apiClient(
      BASE_URL + `api/reviewer/dt/revert-lot?reviewerId=${userId}&lotId=${lotId}&targetId=${targetId}&studentId=${studentId}`,
      requestOptions
    );
    return response;
  } catch (error) {
    console.log(error);
    return error;
  }
};


export const submitWAVForUser = (payload, sentenceId, sourceId) => async (dispatch, getState) => {
  const state = getState();
  const { token, userId } = state.studentAuth;

  const requestOptions = {
    method: "POST",
    credentials: "include",
    headers: {
      "Authorization": `Bearer ${token}`,
    },
    body: payload
  };

  try {
    const response = await apiClient(
      BASE_URL + `api/student/ts/upload-recording?sentenceId=${sentenceId}&studentId=${userId}&sourceId=${sourceId}`,
      requestOptions
    );
    return response;
  } catch (error) {
    console.log(error);
    return error;
  }
};



export const validateWAVForUser = (sentenceId, sourceId) => async (dispatch, getState) => {
  const state = getState();
  const { token, userId } = state.studentAuth;

  const requestOptions = {
    method: "POST",
    credentials: "include",
    headers: {
      "Authorization": `Bearer ${token}`,
    },
  };

  try {
    const response = await apiClient(
      BASE_URL + `api/student/ts/validate-recording?sentenceId=${sentenceId}&studentId=${userId}&sourceId=${sourceId}`,
      requestOptions
    );
    return response;
  } catch (error) {
    console.log(error);
    return error;
  }
};


export const getLotsForDictionary = (subTab) => async (dispatch, getState) => {
  const state = getState();
  const { userId, token, role } = state.studentAuth;

  const requestOptions = {
    method: "GET",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    },
  };

  const url = role === 'REVIEWER' ? subTab === 'assigned' ? `api/reviewer/dt/assigned-lots?reviewerId=${userId}` : `api/reviewer/dt/completed-lots?reviewerId=${userId}`
    : subTab === 'assigned' ? `api/student/dt/assigned-lots?studentId=${userId}` : `api/student/dt/completed-lots?studentId=${userId}`

  try {
    const response = await apiClient(
      BASE_URL + url,
      requestOptions
    );
    return response;
  } catch (error) {
    console.log(error);
    return error;
  }
};


export const getRejectedSentencesForReviewerDict = () => async (dispatch, getState) => {
  const state = getState();
  const { userId, token, role } = state.studentAuth;

  const requestOptions = {
    method: "GET",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    },
  };

  const url = `api/reviewer/tt/assigned-sentences?reviewerId=${userId}`;

  try {
    const response = await apiClient(
      BASE_URL + url,
      requestOptions
    );
    return response;
  } catch (error) {
    console.log(error);
    return error;
  }
};


export const updateWordDetails = (payload) => async (dispatch, getState) => {
  const state = getState();
  const { userId, token, role } = state.studentAuth;

  const requestOptions = {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    },
    body: JSON.stringify(payload)
  };

  const url = `api/student/dt/validate-word?studentId=${userId}`;

  try {
    const response = await apiClient(
      BASE_URL + url,
      requestOptions
    );
    return response;
  } catch (error) {
    console.log(error);
    return error;
  }
};